export const DELETE_TENANT_DATASOURCE_FILTERS_MUTATION = `
  mutation($ids: [Int!]!) {
    deleteTenantDatasourceFilter(ids: $ids)
  }
`;

export type DeleteTenantDatasourceFilterResponse = {
  deleteTenantDatasourceFilter: Array<number>
}
